import type { RouterToolbarHostProps, RouterToolbarItemProps } from './native.types';

export function RouterToolbarHost(props: RouterToolbarHostProps) {
  return null;
}

export function RouterToolbarItem(props: RouterToolbarItemProps) {
  return null;
}
